import React from "react";
import ReactTooltip from "react-tooltip";
import {
  PRICE_TYPE,
  getPriceType,
  formatCPMFromAPI,
} from "./UPRSegmentationHelper";

import { FaTimes } from "react-icons/fa";

class PriceUnit extends React.Component {
  constructor(props) {
    super(props);

    const { readOnly = false } = this.props;

    this.state = {
      readOnly,
      id: `price-unit-${Math.floor(Math.random() * 100000)}`,
    };

    this.handleUnitClicked = this.handleUnitClicked.bind(this);
    this.handleUnitDeleted = this.handleUnitDeleted.bind(this);
  }

  handleUnitClicked() {
    if (!this.state.readOnly && this.props.handleUnitClicked) {
      this.props.handleUnitClicked();
    }
  }

  handleUnitDeleted() {
    if (!this.state.readOnly && this.props.handleUnitDeleted) {
      this.props.handleUnitDeleted();
    }
  }

  render() {
    const {
      price,
      selected,
      textColor = "text-gray-800",
      tooltip,
      isTextOnly = false,
    } = this.props;

    const { readOnly, id } = this.state;

    const { type } = getPriceType(price);

    let content = "";
    if (type === PRICE_TYPE.TARGET_CPM) {
      content = (
        <>
          <div>CPM</div>
          <div className="font-semibold">{formatCPMFromAPI(price)}</div>
        </>
      );
    } else if (type === PRICE_TYPE.FLOOR) {
      content = (
        <>
          <div>Floor</div>
          <div className="font-semibold">{price}</div>
        </>
      );
    } else if (type === PRICE_TYPE.LGO) {
      content = (
        <>
          <div className="font-semibold">LGO</div>
        </>
      );
    } else if (type === PRICE_TYPE.ALGO) {
      content = (
        <>
          <div className="font-semibold">ALGO</div>
        </>
      );
    } else {
      content = (
        <>
          <div className="font-semibold">No UPR</div>
        </>
      );
    }

    return (
      <div data-tip data-for={id}>
        <div
          className={`rounded ${
            isTextOnly ? "" : "border border-gray-400"
          } flex items-center justify-center gap-1 ${
            selected
              ? "bg-blue-600 text-white"
              : `${textColor} bg-gray-100 hover:bg-gray-200`
          } ${
            readOnly
              ? "pointer-events-none px-1 text-xs"
              : "cursor-pointer px-2 py-1 text-sm"
          }`}
          onClick={() => this.handleUnitClicked()}
        >
          {content}

          {!readOnly && (
            <span
              className="cursor-pointer text-xs text-gray-500 hover:text-gray-600"
              onClick={(e) => {
                e.stopPropagation();
                this.handleUnitDeleted();
              }}
            >
              <FaTimes />
            </span>
          )}
        </div>
        {tooltip && (
          <ReactTooltip id={id} type="dark" effect="solid" place="top">
            {tooltip}
          </ReactTooltip>
        )}
      </div>
    );
  }
}

export default PriceUnit;
